import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { getPlanTypeName } from '@app/common/src/utils/getPlanTypeName'

export enum UpsellLocation {
  LANDING_PAGE = 'landing page',
  TEMPLATES_PAGE = 'templates page',
  SHOPPING_CART = 'shopping cart',
  PDP_PAGE = 'pdp page'
}

export const DiscountTier = {
  FREE: {
    tier: 'free',
    label: getPlanTypeName(PlanType.FREE),
    upsell: 'PRO'
  },
  PRO: {
    tier: 'pro',
    label: getPlanTypeName(PlanType.PRO),
    upsell: 'PROPLUS'
  },
  PROPLUS: {
    tier: 'proplus',
    label: getPlanTypeName(PlanType.PRO_PLUS_ORG),
    upsell: 'PROFLEX'
  },
  PROFLEX: {
    tier: 'proflex',
    label: getPlanTypeName(PlanType.PRO_FLEX),
    upsell: 'ENTERPRISE'
  },
  ENTERPRISE: {
    tier: 'enterprise',
    label: getPlanTypeName(PlanType.ENTERPRISE),
    upsell: ''
  }
}
